import image1 from '../images/contact.webp'
import styles from './InfoContacte.module.css'

const Info = () => {

  return (
    <div className={styles.infoContainer}>
      <div className={styles.infoText}>
        <h1 className={styles.title}>Contacta'ns i t'informem!</h1>
        <h2 className={styles.title2}>Volem ajudar-te a tu i a la teva organització a dedicar el temps a les persones i no als informes.</h2>
        <h1 className={styles.title3}><a href="mailto:codelabosona@gmail.com?subject=Informació Socialin&body=Bon dia, voldria més informació sobre Socialin.">codelabosona@gmail.com</a></h1>
      </div>
      <img className={styles.contactImage} src={image1} alt="Foto contacte"></img>
    </div>
  );
};

export default Info;
